export const chunkString = (text: string, chunkSize: number) => {
  const chunks: string[] = [];
  const length = text?.length || 0;
  const iterations = Math.ceil(length / chunkSize);

  for (let i = 0; i < iterations; i++) {
    const start = i * chunkSize;
    const end = start + chunkSize;
    const currentChunk = text.slice(start, end);
    chunks.push(currentChunk);
  }
  return chunks;
};
